import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import user from './modules/user';
import contracts from './modules/contracts';
import establishments from './modules/establishments';
import billingSchedule from './modules/billing_schedule';
import participants from './modules/participants';
import staffs from './modules/staffs';

import modules from './modules/modules';
import access from './modules/access';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    user,
    contracts,
    billingSchedule,
    establishments,
    participants,
    staffs,
    modules,
    access,
  },
  strict: false, // debug,
  getters: {
    getField,
  },
  mutations: {
    updateField,
  },
});
